import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  LOAD_CASE_LIST,
  LOAD_CASE_LIST_SUCCESS,
  LOAD_CASE_LIST_ERROR,
} from '../type';

const packageReducer = handleActions(
  new Map([
    [
      LOAD_CASE_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            caseListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_CASE_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            caseListLoading: { $set: false },
          },
          caseList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_CASE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            caseListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default packageReducer;
